







































































































import * as Util from '@/util.ts';
import * as c from '@/constants.ts';
import { eAttributeSelectionTypes } from '@/enums.ts';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      localShowIndeterminate: false,
      showExplainShowIndeterminate: false,
      eAttributeSelectionTypes,
      localRanges: {
        ...this.$store.state.filters.ranges,
      },
      localSelectedAttributes: {
        ...this.$store.state.filters.selectedAttributes,
      },
    };
  },
  computed: {
    cannotApplyFilters(): boolean {
      return !Object.keys(this.filters.selectedAttributes).length && !this.filterRanges.length;
    },
    filters(): FilterObject {
      return this.$store.state.filters;
    },
    filterRanges(): any[] {
      const filters = this.$store.state.filters;

      const filterRangesWhereHighestValueDoesNotEqualLowest = Object.keys(filters.ranges).filter((key: any) => {
        return filters.highestValues[key] && filters.highestValues[key] !== filters.lowestValues[key];
      });
      return filterRangesWhereHighestValueDoesNotEqualLowest;
    },
  },
  methods: {
    toggleAttribute(attribute: string) {
      if (isNaN(this.$data.localSelectedAttributes[attribute])) {
        this.$data.localSelectedAttributes[attribute] = this.$data.eAttributeSelectionTypes.unselected;
      }
      // Use the below line for affirmative selections only.
      if (this.$data.localSelectedAttributes[attribute] < this.$data.eAttributeSelectionTypes.positive) {
        // Use the below line for affirmative and negative selections.
        // if (this.$data.localSelectedAttributes[attribute] < this.$data.eAttributeSelectionTypes.negative) {
        this.$data.localSelectedAttributes[attribute]++;
      } else {
        this.$data.localSelectedAttributes[attribute] = this.$data.eAttributeSelectionTypes.unselected;
      }
      this.$forceUpdate();
    },
    camelToTitleCase(str: string) {
      return Util.camelToTitleCase(str);
    },
    onApply(closeAfter: boolean = true) {
      const localRanges = { ...this.$data.localRanges };
      this.$store.commit('setFilterObject', {
        ...this.$store.state.filters,
        showIndeterminate: this.$data.localShowIndeterminate,
        selectedAttributes: {
          ...this.$store.state.filters.selectedAttributes,
          ...this.$data.localSelectedAttributes,
        },
        ranges: {
          ...this.$store.state.filters.ranges,
          ...localRanges,
        },
      } as FilterObject);
      if (closeAfter) {
        this.onCancel();
      }
    },
    onClear() {
      const filterSelectedAttributesCopy = {
        ...this.$store.state.filters.selectedAttributes,
      };

      // Zero out the selected attributes to unselect them.
      Object.keys(filterSelectedAttributesCopy).forEach((key: string) => {
        filterSelectedAttributesCopy[key] = 0;
      });

      this.$data.localShowIndeterminate = false;
      this.$data.localSelectedAttributes = { ...filterSelectedAttributesCopy };

      c.FOOD_VALUES.forEach((fv: string) => {
        const currSlider = this.$refs[`${fv}Slider`] as any;
        if (currSlider) {
          this.$data.localRanges[fv] = [this.$store.state.filters.lowestValues[fv], this.$store.state.filters.highestValues[fv]]; // Reset values to min and max.
          currSlider.isActive = false; // Uncheck all the checkboxes.
        }
      });

      this.onApply(false);
    },
    reset() {
      this.$data.localRanges = {
        ...this.$store.state.filters.ranges,
      };
      this.$data.localSelectedAttributes = {
        ...this.$store.state.filters.selectedAttributes,
      };
    },
    onCancel() {
      this.$router.go(-1);
    },
  },
});
